var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37492 7.5H8.62492C8.41792 7.5 8.24992 7.668 8.24992 7.875V13.125C8.24992 13.332 8.41792 13.5 8.62492 13.5H9.37492C9.58192 13.5 9.74992 13.332 9.74992 13.125V7.875C9.74992 7.668 9.58192 7.5 9.37492 7.5ZM8.6253 4.5H9.3753C9.5823 4.5 9.7503 4.668 9.7503 4.875V5.625C9.7503 5.832 9.5823 6 9.3753 6H8.6253C8.41793 6 8.2503 5.832 8.2503 5.625V4.875C8.2503 4.668 8.41793 4.5 8.6253 4.5Z",
    fill: "#E87722"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75ZM9 17.25C13.5563 17.25 17.25 13.5563 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 13.5563 4.44365 17.25 9 17.25Z",
    fill: "#E87722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.db22bf740486a33d63d640c42dc14d5f.svg";
export { ForwardRef as ReactComponent };